import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import Table from '../../shared/Table'
import Button from '../../shared/Button';
import styles from './styles.scss';


export class UsersListTable extends React.Component {
  static get propTypes() {
    return {
      users: PropTypes.array,
      onChangeStatus: PropTypes.func,
      currentUserId: PropTypes.string
    };
  }

  static get defaultProps() {
    return {
      users: []
    };
  }

  get headers() {
    return [
      'Company Name',
      'Name',
      'Email',
      'User Type',
      'Status',
      ''
    ];
  }

  get rows() {
    return this.props.users.map(({
      id,
      email,
      enabled,
      company={},
      firstName,
      lastName,
      roles=[]
    }) => {
      return [
        company && company.name,
        `${firstName} ${lastName}`,
        email,
        roles[0],
        enabled ? 'Active' : 'Disabled',
        this.getActions(id, email, enabled)
      ];
    });
  }

  getActions(userId, email, enabled) {
    return (
      <div className='dropdown'>
        <Button
          className='dropdown-toggle'
          kind='borderless'
          data-toggle='dropdown'>
            Actions
        </Button>
        <div className='dropdown-menu dropdown-menu-left'>
          <Link
            to={{
              pathname:`/users/${userId}`,
              state: { editMode: true }
            }}
            className='dropdown-item'>
              <i className={`fa fa-pencil mr-2 ${styles.actionIcon}`}/>Edit
          </Link>
          <If condition={userId !== this.props.currentUserId}>
              <a
                className='dropdown-item'
                href="#"
                onClick={() => this.props.onChangeStatus(userId, email, enabled)}
              >
                <i className={`fa fa-user mr-2 ${styles.actionIcon}`}/>{enabled ? 'Deactivate' : 'Activate'}
              </a>
          </If>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='text-center'>
        <Table headers={this.headers} rows={this.rows}/>
      </div>
    );
  }
}

const mapStateToProps = ({ profile }) => ({
  currentUserId: profile.id,
  currentUserRole: profile.role
});

export default connect(mapStateToProps)(
  UsersListTable
);


// WEBPACK FOOTER //
// src/components/usersList/UsersListTable/index.jsx